import getGstateName from "./getGstateName";
import getAddressComponentByType from "./getAddressComponentByType";

export default function parseAddressComponents(addressComponents) {
  let stateComponent;
  let countyComponent;
  let zipCodeComponent;
  let cityComponent;
  let address;

  for (let i = 0; i < addressComponents.length; i++) {
    if (!address) {
      address = addressComponents[i].formatted_address;
    }
    if (!zipCodeComponent) {
      zipCodeComponent = getAddressComponentByType(addressComponents[i].address_components, "postal_code");
    }
    if (!cityComponent) {
      cityComponent = getAddressComponentByType(addressComponents[i].address_components, "locality");
    }
    if (!stateComponent) {
      stateComponent = getAddressComponentByType(addressComponents[i].address_components, "administrative_area_level_1");
    }
    if (!countyComponent) {
      countyComponent = getAddressComponentByType(addressComponents[i].address_components, "administrative_area_level_2");
    }
    if (stateComponent && countyComponent) {
      break;
    }
  }

  return {
    address,
    city: cityComponent && cityComponent.long_name,
    zipCode: zipCodeComponent && zipCodeComponent.long_name,
    state: stateComponent && stateComponent.long_name,
    stateCode: stateComponent && stateComponent.short_name,
    county: getGstateName(countyComponent && countyComponent.long_name),
  };
}
